
// import { } from '@/api/templateEvaluate';
import { Component, Prop, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import { modifyCompanySet } from "@/api/system";
import { getUserInfo } from "@/api/users";
import {
  addEvaluateDimension,
  delEvaluateDimension,
  getDimensionList,
  modifyEvaluateDimension,
  sendDimensionRelease,
} from "@/api/evaluateDimension";

@Component({
  name: "SettingTemplateEvaluateCustom",
  components: {},
})
export default class extends Vue {
  private isOpened: boolean = false;
  private radioWhose = "1";
  private vipLev = 3;
  private tableData: any = [];

  private listLoading = false;
  private dialogSetPercent = false;

  private dataTablePercent: any = [];
  private selected: any = [];

  private pagination:any={
    currentPage: 1,
    pageSize: 10,
    total: 0,
  }

  private orderAutoEvaluateDate: any = [1,2,3, 4, 5, 6, 7, 30, 60, 90]
  private isOrderAutoEvaluate: any = false;
  private orderAutoEvaluateNumber: any = 3;

  private isHaveOpen: any = false;

  created() {
    if (UserModule.getCompany) {
      this.isOpened =
        parseInt(UserModule.getCompany.is_open_diy_evaluate) === 1;
      this.radioWhose = UserModule.getCompany.diy_evaluate_user_type;
      this.vipLev = parseInt(UserModule.getCompany.vip_level.substr(0, 1));

      this.isOrderAutoEvaluate = parseInt(UserModule.getCompany.is_order_auto_evaluate)===1;
      this.orderAutoEvaluateNumber = parseInt(UserModule.getCompany.order_auto_evaluate_number);
    }
    this.getList(0);
  }
  private getList(type:number) {
    this.listLoading = true;
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.user_name = UserModule.getUserName;
    params.company_name = UserModule.getCompanyName;
    if(type===1){
      params.page=1;
      params.size=9999;
    }else{
      params.page=this.pagination.currentPage;
      params.size=this.pagination.pageSize;
    }
    getDimensionList(params)
      .then((res: any) => {
        this.listLoading = false;
        if (res.data) {
          this.pagination.total=res.data.count
          if(type===0){
            this.tableData = res.data.list;
            this.isHaveOpen = parseInt(res.data.is_have_released) === 1;
          }else{
            this.dataTablePercent=res.data.list;
          }
        }else{
          if(type===0){
             this.pagination.total=0
            this.tableData = [];
            this.isHaveOpen =false;
          }
        }
      })
      .catch((err) => {
        this.listLoading = false;
      });
  }
  private handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.getList(0);
  }

  private handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList(0);
  }
  private radioChange(){
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.diy_evaluate_user_type = this.radioWhose;
    this.saveCopanySet(params);
  }

  private selectChangeAutoEvaluate(v:any) {
    if (!this.isOrderAutoEvaluate) {
        return;
    }
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.is_order_auto_evaluate = this.isOrderAutoEvaluate ? 1 : 0;
    params.order_auto_evaluate_number = this.orderAutoEvaluateNumber;
    this.saveCopanySet(params);
  }


  private openEva() {
    this.isOpened = !this.isOpened;
    if (this.isOpened) {
      if (!this.isHaveOpen) {
        this.showErrorMsg("请发布后启用");
        this.isOpened =
          parseInt(UserModule.getCompany.is_open_diy_evaluate) === 1;
        return;
      }
    }
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.is_open_diy_evaluate = this.isOpened ? 1 : 0;
    params.diy_evaluate_user_type = this.radioWhose;
    this.saveCopanySet(params);
  }
  private openAutoEva() {
    this.isOrderAutoEvaluate = !this.isOrderAutoEvaluate;
    if (this.isOrderAutoEvaluate) {
      if(!this.isOpened){
        this.showErrorMsg("请先启用自定义评价"); 
        this.isOrderAutoEvaluate = false;
        return;
      }
      if (this.orderAutoEvaluateNumber<=0) {
        this.showErrorMsg("请选择天数");
        this.isOrderAutoEvaluate = false;
        return;
      }
    }
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.is_order_auto_evaluate = this.isOrderAutoEvaluate ? 1 : 0;
    params.order_auto_evaluate_number = this.orderAutoEvaluateNumber;
    this.saveCopanySet(params);
  }
  private saveCopanySet(params: any) {
    modifyCompanySet(params)
      .then((res) => {
        this.showSuccessMsg((res as any).msg);
        this.updateInfo();
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
        this.updateInfo();
      });
  }
  private async updateInfo() {
    await getUserInfo({
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
    }).then(async(res: any) => {
      await UserModule.setLogin(res.data);
    });
    if (UserModule.getCompany) {
      this.isOpened =
        parseInt(UserModule.getCompany.is_open_diy_evaluate) === 1;
      this.radioWhose = UserModule.getCompany.diy_evaluate_user_type;

      this.isOrderAutoEvaluate = parseInt(UserModule.getCompany.is_order_auto_evaluate)===1;
      this.orderAutoEvaluateNumber = parseInt(UserModule.getCompany.order_auto_evaluate_number);

    }
  }

  private angleHandle(val: any) {
    let that = this;
    let value = "";
    if (val) {
      value = val.name;
    }
    this.$prompt("", "添加维度", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputValue: value,
      inputPlaceholder: "请输入维度名称",
      inputPattern: /^.{1,50}$/,
      inputErrorMessage: "请输入1-50个字",
    })
      .then(({ value }: any) => {
        that.add(value, val);
      })
      .catch(() => {});
  }
  private add(value: any, v: any) {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.user_name = UserModule.getUserName;
    params.name = value;
    if (v && v.id) {
      params.dimension_id = v.id;
      modifyEvaluateDimension(params)
        .then((res: any) => {
          this.showSuccessMsg(res.msg);
          this.getList(0);
        })
        .catch((err) => {
          this.showErrorMsg(err.msg);
        });
    } else {
      addEvaluateDimension(params)
        .then((res: any) => {
          this.showSuccessMsg(res.msg);
          this.getList(0);
        })
        .catch((err) => {
          this.showErrorMsg(err.msg);
        });
    }
  }

  private deleteHandle(val: any) {
    let _this = this;
    this.$confirm("确认删除吗?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        _this.del(val);
      })
      .catch(() => {});
  }
  private del(val: any) {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.user_name = UserModule.getUserName;
    params.dimension_id = val.id;
    delEvaluateDimension(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getList(0);
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  private submitHandle() {
    this.selected=[];
    this.dialogSetPercent = true;
    this.getList(1)
  }
  private confirmPercent(val:any){
    let isNumber=/^\d*$/.test(val.target.value);
    val.target.value=val.target.value.replace(/\D/g,'')
    if(!isNumber||val.target.value<1||val.target.value>100){
      this.showErrorMsg('只能输入1-100的整数');
    }
    val.target.value=(val.target.value>=1&&val.target.value<=100&&val.target.value.match(/^\d*/g)[0])||null
  }
  private confirmHandle(val: any) {
    if(this.selected&&this.selected.length<1){
      this.showErrorMsg('请选择维度')
      return
    }
    let num=0;
    let isHaveNum=true;
    this.selected.map((s:any)=>{
      if(!s.percent){
        isHaveNum=false;
      }else{
        num+=parseInt(s.percent)
      }
    })
    console.log(num)
    if(!isHaveNum){
      this.showErrorMsg('请设置权重比例');
      return
    }
    if(num!==100){
      this.showErrorMsg('权重比例不满足100%');
      return
    }
    this.send()
  }
  private send(){
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.user_name = UserModule.getUserName;
    let arr:any=[];
    this.selected.map((s:any)=>{
      arr.push({
        dimension_id:s.id,
        weight:s.percent
      })
    })
    params.dimension_json = JSON.stringify(arr);
    sendDimensionRelease(params)
      .then((res: any) => {
        this.dialogSetPercent=false;
        this.showSuccessMsg(res.msg);
        this.getList(0);
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: "notification-center",
      type: "success",
    });
  }
}
